import React, { useRef, useEffect, useState } from "react";
import mapboxgl from "mapbox-gl";

import geoJson from "../src/lookup/subcontinent.json";
import axios from "axios";

mapboxgl.accessToken =
  "pk.eyJ1IjoiY29zbWljbmV0d29yayIsImEiOiJjbHgwZjZyZjcwMDB3Mmhzbnh2cXZiaXcwIn0.JyvzWag_9Zjx-0Pe2J3nVw";

const Map = ({ selectedServer, setSelectedServer }) => {
  // console.log('tester ', nodeLocations)
  const [nodeLocations, setNodeLocations] = useState([]);
  const [isServerSelectVisible, setIsServerSelectVisible] = useState(false);
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [connectedServer, setConnectedServer] = useState(null);
  const [nodes, setNodes] = useState({});
  const handleChooseClick = () => {
    setIsServerSelectVisible(!isServerSelectVisible);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api.cosmicnetwork.io/api/getNodeWithCountryRegion",
          {
            headers: {
              "api-key": "d6b228dcdcca72562f2385ca26d6fb748d891f35",
              "Content-Type": "application/json",
            },
          }
        );
        let nodes = [];

        // response.data.response.forEach(({ data }) => {
        //   console.log('tester1 ', data)
        //   nodes = nodes.concat(data);
        // });
        // console.log('tester ', nodes);

        setNodeLocations(response.data.response);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
      }
    };

    fetchData();
  }, []);

  console.log("tester nodes ", nodes);
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (selectedContinent) {
      const index = nodeLocations.findIndex(
        (_) => _.continent === selectedContinent
      );
      if (index > -1) {
        setNodes(nodeLocations[index]);
      }
    } else {
      console.log("tester ", nodeLocations);
      // if(!nodes.location) {
      const arr = [];
      nodeLocations.forEach((_) => {
        if (_.continent) arr.push(..._.data);
      });
      setNodes({ data: arr });
      // }
    }
  }, [nodeLocations]);

  const createCustomMarker = (title, size = 100, isCountry = false) => {
    const el = document.createElement("div");
    el.className = "custom-marker";
    el.style.width = `${size}px`;
    el.style.height = `${size}px`;
    el.style.background = isCountry
      ? "linear-gradient(180deg, rgba(70, 236, 184, 0.20) 0%, rgba(39.75, 134, 104.47, 0.20) 100%)"
      : "linear-gradient(180deg, rgba(70, 236, 184, 0.20) 0%, rgba(39.75, 134, 104.47, 0.20) 100%)";
    el.style.borderRadius = "50%";
    el.style.display = "flex";
    el.style.alignItems = "center";
    el.style.justifyContent = "center";
    el.style.cursor = "pointer";

    const innerDiv = document.createElement("div");
    innerDiv.style.width = "40%";
    innerDiv.style.height = "40%";
    innerDiv.style.backgroundColor = isCountry ? "#4BEFAF" : "black";
    innerDiv.style.display = "flex";
    innerDiv.style.alignItems = "center";
    innerDiv.style.justifyContent = "center";
    innerDiv.style.borderRadius = "50%";

    const markerText = document.createElement("div");
    // markerText.textContent = `${title}`;
    markerText.style.margin = "0";
    markerText.style.fontSize = isCountry ? "12px" : "16px";
    markerText.style.fontWeight = "800";
    markerText.style.textAlign = "center";
    markerText.style.color = isCountry ? "#4BEFAF" : "black";
    markerText.style.background = isCountry ? "#4BEFAF" : "#4BEFAF";
    markerText.style.padding = isCountry ? "0" : "7px";
    markerText.style.borderRadius = isCountry ? "0" : "50%";

    innerDiv.appendChild(markerText);
    el.appendChild(innerDiv);

    return el;
  };

  useEffect(() => {
    const tooltip = document.createElement("div");
    tooltip.className = "custom-tooltip";
    tooltip.style.position = "absolute";
    tooltip.style.visibility = "hidden";
    tooltip.style.backgroundColor = "#0B191D";
    tooltip.style.padding = "15px";
    tooltip.style.borderRadius = "8px";
    tooltip.style.color = "white";
    tooltip.style.fontFamily = "Archivo";
    tooltip.style.fontWeight = "700";
    tooltip.style.fontSize = "20px";
    tooltip.style.gap = "20px";
    tooltip.style.textAlign = "center";
    tooltip.style.display = "flex";
    tooltip.style.zIndex = "1000";
    document.body.appendChild(tooltip);

    function positionTooltip(event) {
      const tooltipWidth = tooltip.offsetWidth;
      const tooltipHeight = tooltip.offsetHeight;
      const pageX = event.pageX;
      const pageY = event.pageY;

      tooltip.style.left = `${pageX - tooltipWidth / 2}px`;
      tooltip.style.top = `${pageY - tooltipHeight - 10}px`;
    }

    if (!mapRef.current) {
      const map = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/cosmicnetwork/cm3a03rlu001701pnegaoe4nh/",
        center: [0, 0],
        zoom: 0,
        attributionControl: false,
      });

      map.scrollZoom.disable();

      map.on("load", function () {
        geoJson.features.forEach((feature, index) => {
          const number = index + 1;
          const { title, countries = [] } = feature.properties;
          const coordinates = feature.geometry.coordinates;

          const checkNodesInContinent = nodeLocations.findIndex(
            (_) => _.continent === title
          );
          if (
            checkNodesInContinent === -1 ||
            nodeLocations?.[checkNodesInContinent]?.data?.length === 0
          ) {
            return;
          }
          const customMarker = createCustomMarker(number);
          const marker = new mapboxgl.Marker(customMarker)
            .setLngLat(coordinates)
            .addTo(map);

          let isZoomedIn = false;

          customMarker.addEventListener("click", async () => {
            isZoomedIn = !isZoomedIn;

            if (isZoomedIn) {
              map.flyTo({ center: coordinates, zoom: 3 });
              setSelectedContinent(title);
              document
                .querySelectorAll(".country-marker")
                .forEach((el) => el.remove());
              let countriesPointers = [];
              const index = nodeLocations.findIndex(
                (_) => _.continent === title
              );
              if (index > -1) {
                countriesPointers = nodeLocations[index]?.data || [];
              }
              countriesPointers?.forEach((country, countryIndex) => {
                const countryMarker = createCustomMarker(
                  countryIndex + 1,
                  50,
                  true
                );
                const { latitude, longitude } = country.location;
                countryMarker.className += " country-marker";
                new mapboxgl.Marker(countryMarker)
                  .setLngLat({ lat: latitude, lon: longitude })
                  .addTo(map);
              });

              setIsServerSelectVisible(true);
            } else {
              map.easeTo({
                center: [0, 0],
                zoom: 0,
                bearing: 0, // Reset bearing
                pitch: 0, // Reset pitch
                easing: function (t) {
                  return t;
                },
                duration: 1000, // Duration of the transition in milliseconds
              });

              document
                .querySelectorAll(".country-marker")
                .forEach((el) => el.remove());

              setIsServerSelectVisible(false);
              setSelectedContinent(null);
            }
          });

          customMarker.addEventListener("mouseenter", (event) => {
            tooltip.style.visibility = "visible";

            tooltip.innerHTML = "";

            const serverDiv = document.createElement("div");
            serverDiv.style.display = "flex";
            serverDiv.style.flexDirection = "column";
            serverDiv.style.gap = "7px";

            serverDiv.style.justifyContent = "space-between";
            serverDiv.style.width = "100%";

            const serverLabel = document.createElement("div");
            serverLabel.textContent = `${title} Nodes `;
            serverLabel.style.color = "#01A5CF";
            serverLabel.style.fontSize = "16px";
            const serverValue = document.createElement("div");
            const index = nodeLocations.findIndex((_) => _.continent == title);
            serverValue.textContent =
              index > -1 ? nodeLocations[index]?.data?.length || 0 : 0; //`766`;
            const statusDiv = document.createElement("div");
            statusDiv.style.color = "#01A5CF";
            statusDiv.style.fontSize = "16px";
            // statusDiv.textContent = title;
            serverDiv.appendChild(statusDiv);
            serverDiv.appendChild(serverLabel);
            serverDiv.appendChild(serverValue);

            // const pingDiv = document.createElement("div");
            // pingDiv.style.display = "flex";
            // pingDiv.style.gap = "7px";

            // pingDiv.style.flexDirection = "column";

            // pingDiv.style.justifyContent = "space-between";
            // pingDiv.style.width = "100%";

            // const pingLabel = document.createElement("div");
            // pingLabel.textContent = "Ping";
            // pingLabel.style.color = "#01A5CF";
            // pingLabel.style.fontSize = "16px";
            // const pingValue = document.createElement("div");
            // pingValue.textContent = "130ms"; // Example value

            // pingDiv.appendChild(pingLabel);
            // pingDiv.appendChild(pingValue);

            // tooltip.appendChild(pingDiv);
            tooltip.appendChild(serverDiv);

            positionTooltip(event);
          });

          customMarker.addEventListener("mousemove", (event) => {
            positionTooltip(event);
          });

          customMarker.addEventListener("mouseleave", () => {
            tooltip.style.visibility = "hidden";
          });
        });
      });

      // map.addControl(new mapboxgl.NavigationControl(), "bottom-right");
      mapRef.current = map;
    }

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, [nodeLocations]);

  return <div className="map-container" ref={mapContainerRef} />;
};

export default Map;
